import api from 'apis/merchant-onboarding-service/api';

import { CountryConfig, SelfServeSignupRequest, SsmoCountryConfig } from './types';

export const getCountryConfigs = () =>
  api.get<{ results: CountryConfig[] }>('/merchant-admin/config').then(response => response.data.results);

export const getSsmoCountryConfigs = () =>
  api.get<SsmoCountryConfig>('/merchant-admin/config/ssmo').then(response => response.data);

export const postInboundMerchant = (payload: SelfServeSignupRequest, hCaptchaResponse: string) =>
  api
    .post('/merchant-admin/inbound-merchant', payload, { headers: { 'h-captcha-response': hCaptchaResponse } })
    .then(response => response.data);
